import React from 'react'
import FindAnIndependantFinancialAdviser from '../../features/FindAnIndependantFinancialAdviser'

class Home extends React.Component {

  render () {
    return (
      <FindAnIndependantFinancialAdviser />
    )
  }
}

export default Home
